import React, { Component } from 'react';
import classNames from 'classnames';

import css from './SearchMapGroupLabel.module.css';

const getPreferredImageUrl = listing => {
  const firstImage = listing?.images?.[0] || null;
  const variants = firstImage?.attributes?.variants || {};

  return (
    Object.entries(variants)
      .filter(([name, variant]) => name.startsWith('listing-card') && variant?.url)
      .sort(([, a], [, b]) => (a?.width || 0) - (b?.width || 0))[0]?.[1]?.url ||
    Object.values(variants).find(variant => variant?.url)?.url ||
    null
  );
};

const getStartingPrice = listings => {
  const pricedListings = listings.filter(listing => listing?.attributes?.price?.amount != null);
  if (pricedListings.length === 0) {
    return { markerListing: listings[0], label: null };
  }

  const markerListing = pricedListings.reduce((lowest, current) => {
    return current.attributes.price.amount < lowest.attributes.price.amount ? current : lowest;
  });
  const price = markerListing.attributes.price;
  const formattedPrice = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: price.currency,
    currencyDisplay: 'narrowSymbol',
    minimumFractionDigits: price.amount % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(price.amount / 100);

  return { markerListing, label: `from ${formattedPrice}` };
};

/**
 * Grouped artist marker: image + lowest starting price + listing-count badge.
 */
class SearchMapGroupLabel extends Component {
  shouldComponentUpdate(nextProps) {
    const hasSameAmountOfListings = nextProps.listings.length === this.props.listings.length;
    const hasSameActiveStatus = this.props.isActive === nextProps.isActive;
    const hasSameRefreshToken =
      this.props.mapComponentRefreshToken === nextProps.mapComponentRefreshToken;

    return !(hasSameAmountOfListings && hasSameActiveStatus && hasSameRefreshToken);
  }

  render() {
    const { className, rootClassName, listings, onListingClicked, isActive } = this.props;
    const classes = classNames(rootClassName || css.root, className, {
      [css.rootActive]: isActive,
    });
    const { markerListing, label } = getStartingPrice(listings);
    const imageUrl = getPreferredImageUrl(markerListing);

    return (
      <button className={classes} onClick={() => onListingClicked(listings)}>
        <span className={css.markerVisual}>
          {imageUrl ? (
            <span className={css.artistPhotoWrap} aria-hidden="true">
              <img className={css.artistPhoto} src={imageUrl} alt="" />
            </span>
          ) : (
            <span className={css.artistPhotoFallback} aria-hidden="true" />
          )}
          <span className={css.countBadge}>{listings.length}</span>
        </span>
        <span className={classNames(css.priceLabel, { [css.priceLabelActive]: isActive })}>
          {label || `${listings.length} services`}
        </span>
      </button>
    );
  }
}

export default SearchMapGroupLabel;
